import { termsData } from "assets/data/termsAndPrivacy";
import FeedLayout from "layouts/files/FeedLayout";
import { Link } from "react-router-dom";
import { PrivacyItem, SVG } from "ui";

const Terms = () => {
    return (
        <FeedLayout pageTitle="help" hideSideCards>
            <div className="moment-mark-page pb-40">
                <div className="d-flex flex-j-between flex-a-center gap-10 w-full text-center mb-30 mt-20">
                    <Link to="/">
                        <SVG svg="chevron-left" size={24} />
                    </Link>
                    <h1 className="fw-700 fs-12em">Terms and Conditions</h1>

                    <div></div>
                </div>

                <div className="card pr-20 pl-20 pt-20 pb-20">
                    {termsData.map((p) => (
                        <PrivacyItem title={p.title}>
                            <div
                                dangerouslySetInnerHTML={{ __html: p.body }}
                            ></div>
                        </PrivacyItem>
                    ))}
                </div>
                <div className="d-flex flex-j-start w-full pl-20 mt-20 mb-10">
                    <Link to="/help">Help</Link>
                </div>
                <div className="d-flex flex-j-start w-full pl-20 mt-20 mb-10">
                    <Link to="/privacy">Privacy Policy</Link>
                </div>
            </div>
        </FeedLayout>
    );
};

export default Terms;
